import { render, staticRenderFns } from "./msg8.vue?vue&type=template&id=57b2799e&"
import script from "./msg8.vue?vue&type=script&lang=js&"
export * from "./msg8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports